export default "__VITE_ASSET__ded646dd__"